import React from 'react';
import { Box, Typography, Container, Grid, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Parallax } from 'react-scroll-parallax';
import colors from '../../theme/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const AboutSection: React.FC = () => (
  <Container maxWidth="lg" sx={{ py: 10, position: 'relative', zIndex: 1 }} id="about">
    <Parallax speed={-10}>
      <Box sx={{ position: 'absolute', top: -140, left: '-10%', transform: 'translateX(-50%)', width: '90%', height: 800, opacity: 0.10, zIndex: 0 }}>
        <img src={require('../../assets/syrdevuae_logo.svg').default} alt="SyrDevUae Illustration" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </Box>
    </Parallax>
    <Grid container spacing={6} alignItems="center" sx={{ position: 'relative', zIndex: 1, flexDirection: { xs: 'column', md: 'row' } }}>
      {/* Image on the left (desktop), top (mobile) */}
      
      {/* Text content on the right (desktop), below (mobile) */}
      <Grid size={{ xs: 12, md: 7 }}>
        <Box>
          <Typography variant="h3" color="primary" fontWeight={700} gutterBottom>
            About SyrDevUae
          </Typography>
          <Box sx={{ height: 4, width: 48, borderRadius: 2, background: colors.accent, mb: 3 }} />
          <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
            We are a vibrant community of Syrian developers, engineers, and tech enthusiasts in the UAE. Our mission is to connect, empower, and inspire through knowledge sharing, networking, and professional growth.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Whether you are a student, a professional, or a tech leader, SyrDevUae is your gateway to learning, collaboration, and new opportunities. Join us for events, courses, and forums designed to help you grow and succeed in the tech world.
          </Typography>
          <Typography variant="subtitle1" color="primary" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
            Our Mission
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            To empower Syrian tech talent in the UAE and beyond by fostering a collaborative, innovative, and supportive environment for learning and professional growth.
          </Typography>
          <Typography variant="subtitle1" color="primary" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
            Our Vision
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            To be the leading hub for Syrian developers in the region, recognized for our impact, inclusivity, and commitment to excellence.
          </Typography>
          <Typography variant="subtitle1" color="primary" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
            Our Values
          </Typography>
          <List dense>
            <ListItem>
              <ListItemIcon><CheckCircleIcon sx={{ color: colors.accent }} /></ListItemIcon>
              <ListItemText primary="Collaboration & Community" />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleIcon sx={{ color: colors.accent }} /></ListItemIcon>
              <ListItemText primary="Continuous Learning" />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleIcon sx={{ color: colors.accent }} /></ListItemIcon>
              <ListItemText primary="Innovation & Excellence" />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleIcon sx={{ color: colors.accent }} /></ListItemIcon>
              <ListItemText primary="Diversity & Inclusion" />
            </ListItem>
          </List>
          <Button variant="contained" color="primary" size="large" sx={{ mt: 3, fontWeight: 700 }} href="#team">
            Meet the Team
          </Button>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <Box sx={{
          width: '100%',
          textAlign: 'center',
          p: { xs: 0, md: 3 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: { md: '100%' },
        }}>
          <Box sx={{
            background: colors.lightBg,
            borderRadius: 4,
            boxShadow: 2,
            display: 'inline-block',
            p: 2,
            maxWidth: 520,
            width: '100%',
          }}>
            <img src={require('../../assets/about.png')} alt="SyrDevUae" style={{ width: '100%', maxWidth: 520, minWidth: 140, borderRadius: 8 }} />
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Container>
);

export default AboutSection; 